export const currency = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMediumMaxWidth,
    width: '100%',
});
